import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=c9efced2&scoped=true"
import script from "./OrganizationCard.vue?vue&type=script&lang=js"
export * from "./OrganizationCard.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCard.vue?vue&type=style&index=0&id=c9efced2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9efced2",
  null
  
)

export default component.exports